// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"572":"aa4d82b9","638":"aca7e1ae","703":"f1a1a189","718":"8c8c0f70","753":"5f148e7c","779":"afd7cad9","930":"4f46c967"}[chunkId] + ".chunk.js";
};